/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ReviewCircledIcon = /*#__PURE__*/ createSvgIcon(
  'ReviewCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M7.125 11.5h1.016a.645.645 0 00.453-.188l2.937-2.937a.96.96 0 00.281-.672.773.773 0 00-.078-.336c-.052-.11-.12-.21-.203-.304l-.562-.594a.948.948 0 00-.672-.282.961.961 0 00-.672.282L6.687 9.406a.624.624 0 00-.187.453v1.016c0 .177.06.325.18.445s.268.18.445.18zm.313-.938V9.97L9.015 8.39l.312.28.281.313-1.578 1.579h-.594zm1.89-1.89l.281.312-.593-.593.312.28zm.406 2.828h3.641c.177 0 .325-.06.445-.18s.18-.268.18-.445a.605.605 0 00-.18-.445.605.605 0 00-.445-.18h-2.39l-1.25 1.25zM6.5 14l-1.438 1.438c-.197.197-.424.242-.68.132A.588.588 0 014 14.984V5.25c0-.344.122-.638.367-.883S4.907 4 5.25 4h10c.344 0 .638.122.883.367s.367.54.367.883v7.5c0 .344-.122.638-.367.883a1.204 1.204 0 01-.883.367H6.5zm-.531-1.25h9.281v-7.5h-10v8.203l.719-.703z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default ReviewCircledIcon;
